module.exports = __webpack_public_path__ + "img/feel-good-stretches.a090d4db.jpg";